import { render, staticRenderFns } from "./download.vue?vue&type=template&id=781a1f13&scoped=true&"
import script from "./download.vue?vue&type=script&lang=ts&"
export * from "./download.vue?vue&type=script&lang=ts&"
import style0 from "./download.vue?vue&type=style&index=0&id=781a1f13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781a1f13",
  null
  
)

export default component.exports